import { IS } from 'utils'

interface IUseExceptionReturn {
  createCustomException: (_props: unknown) => void
  getException: (error: Error) => any
}

const useException = (): IUseExceptionReturn => {
  const createCustomException = (props: unknown): void => {
    throw new Error(JSON.stringify(props))
  }

  const getException = (error: Error) => {
    if (IS.json(error.message)) {
      const exception = JSON.parse(error.message)

      return exception
    }

    return error
  }

  return {
    createCustomException,
    getException,
  }
}

export default useException
